import { useEffect, useState } from "react";
import api from "../../lib/api";
import { EmptyState, Loading, inr } from "../../components/shared";
import { FileText } from "lucide-react";

export default function ExpertCommercial() {
  const [rows, setRows] = useState(null);
  useEffect(() => {
    api
      .get("/expert-commercial/expert")
      .then((response) => setRows(response.data))
      .catch(() => setRows([]));
  }, []);
  if (!rows) return <Loading />;
  const notice = (
    <div
      className="border border-amber-200 bg-amber-50 p-3 text-xs text-amber-800"
      data-testid="expert-commercial-calc-only-notice"
    >
      Calculation-only — figures below are{" "}
      <strong>calculated entitlements</strong>, not completed collections. Any
      future settlement requires a separately approved manual process.
    </div>
  );
  if (!rows.length)
    return (
      <div className="space-y-3">
        {notice}
        <EmptyState icon={FileText} title="No commercial records yet" />
      </div>
    );
  return (
    <div className="space-y-3" data-testid="expert-commercial-records">
      {notice}
      {rows.map((row) => (
        <article
          className="border bg-card p-4"
          data-testid={`expert-commercial-${row.commercial_record_id}`}
          key={row.commercial_record_id}
        >
          <div className="flex flex-wrap justify-between gap-2">
            <div>
              <p className="font-semibold">{row.display_id}</p>
              <p className="text-xs text-muted-foreground">
                Session {row.session_id} · {row.actual_duration_seconds}s
              </p>
            </div>
            <span className="text-xs font-semibold">
              {row.status.replaceAll("_", " ")}
            </span>
          </div>
          <div className="mt-3 grid grid-cols-2 gap-3 text-sm sm:grid-cols-4">
            <Metric
              label="Gross Calculated Value"
              value={inr(Number(row.gross))}
            />
            <Metric
              label="Platform Calculated Share"
              value={inr(Number(row.platform_share))}
            />
            <Metric
              label="Expert Calculated Entitlement"
              value={inr(Number(row.expert_entitlement))}
            />
            <Metric
              label="Commercial Status"
              value={row.status.replaceAll("_", " ")}
            />
          </div>
        </article>
      ))}
    </div>
  );
}

function Metric({ label, value }) {
  return (
    <div>
      <p className="text-xs text-muted-foreground">{label}</p>
      <p className="font-medium">{value}</p>
    </div>
  );
}
